import React from 'react';
import { DeleteBlock } from '../Blocks/shared/DeleteBlock';
import { newBlankBlock } from './newBlankBlock';
import { ExtractionFormType } from 'concepts/Extraction/ExtractionFormType';
import {
  TemplateViewModel,
  updateBlock,
} from 'concepts/Extraction/ViewModel/TemplateViewModel';
import { applyBlockAction } from 'concepts/Extraction/Blocks/BlockAction';
import { Factory } from 'concepts/Extraction/Blocks/factory';
import { Stack } from 'system/base/Stack';

type ChangeHandler = (prevViewModel: TemplateViewModel) => TemplateViewModel;

export type BuildSettingsProps = {
  formType: ExtractionFormType;
  viewModel: TemplateViewModel;
  blockID: string | null;
  hasBeenPublishedBefore: boolean;
  onChange: (changer: ChangeHandler) => void;
};

export default function BuildSettings({
  onChange,
  viewModel,
  hasBeenPublishedBefore,
  blockID,
  formType,
}: BuildSettingsProps): JSX.Element | null {
  if (blockID === null) {
    return null;
  }

  const block = viewModel.blocks.find((block) => block.id == blockID);
  if (block == null) {
    return null;
  }

  const EditorSettings = Factory(block).EditorSettings;

  // Same path as the in-row delete, so removing the last block leaves one blank block behind
  const onRemove = () => {
    onChange(
      (viewModel) =>
        applyBlockAction(viewModel, { type: 'remove', blockID: block.id }, () =>
          newBlankBlock(formType)
        ).newViewModel
    );
  };

  return (
    <Stack component="aside" gap>
      {EditorSettings && (
        <EditorSettings
          block={block}
          onChange={(block) => {
            onChange((viewModel) => updateBlock(viewModel, block));
          }}
          onRemove={onRemove}
        />
      )}
      <DeleteBlock
        onRemove={onRemove}
        hasBeenPublishedBefore={hasBeenPublishedBefore}
      />
    </Stack>
  );
}
